import React, { Component, memo, Fragment } from 'react';
import styled from 'styled-components';
import { formatNumber, timestampToString, cecDateStringToHumanRead, voteNumberToString } from '../utils';
import { breakPoints, setup, stage } from '../config';
import InfoIcon from '../assets/info.svg';
import RecallLoading from '../assets/recall-loading.gif';
import Popup from './Popup';
import { fetchDataFromCEC } from '../utils/api';

const { currentStage, updateInterval } = setup;
const { maxMobile } = breakPoints;

const { numberOfElector: defaultNumberOfElector, votingEligiblePopulation } = setup;

const Container = styled.div`
  position: sticky;
  z-index: 5;
  top: 24px;
  width: 100%;
  box-sizing: border-box;
  background-color: #E5E5E5;
  @media(max-width: ${maxMobile}px) {
    height: auto;
    left: 0;
    top: 0px;
    position: relative;
    padding-bottom: 12px;
    padding-top: 12px;
  }
`

const Header = styled.div`
  font-size: 22px;
  font-weight: bold;
  display: flex;
  align-items: center;
  > span {
    margin-right: 10px;
  }
  > img {
    cursor: pointer;
    padding: 3px;
  }
`

const GraphicContainer = styled.div`
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  display: flex;
  margin: 15px 0;
  @media(max-width: ${maxMobile}px) {
    height: 106px;
    margin: 15px 0 23px 0;
  }
`

const GraphicLable = styled.div`
  font-size: 16px;
  font-weight: bold;
`

const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  padding-right: 14px;
  > div:first-child {
    margin-bottom: 47px;
    @media(max-width: ${maxMobile}px) {
      margin-bottom: 22px;
    }
  }
`

const DataContainer = styled.div`
  border-left: 1px solid black;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  position: relative;
  > div:first-child {
    margin-bottom: 20px;
    @media(max-width: ${maxMobile}px) {
      margin-bottom: 14px;
    }
  }
`

const Pass = styled.div`
  left: 50%;
  border-left: 1px dotted;
  bottom: 0;
  height: 65%;
  top: 50%;
  transform: translate(-50%, -60%);
  position: absolute;
  @media(max-width: ${maxMobile}px) {
    height: 71%;
  }
`;

const PassLabel = styled.div`
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  bottom: -40px;
  transform: translateX(-50%);
  white-space: nowrap;
  text-align: center;
`;

const Agree = styled.div`
  height: 48px;
  width: ${props => props.width || 0}%;
  background-color: ${props => props.theme.agreeYellow};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  position: relative;
  > span {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: #FFFFFF;
    font-size: 16px;
    white-space: nowrap;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.8);
  }
  @media(max-width: ${maxMobile}px) {
    height: 28px;
  }
`;

const Disagree = styled.div`
  height: 48px;
  width: ${props => props.width || 0}%;
  background-color: ${props => props.theme.disagreeRed};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  position: relative;
  > span {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: #FFFFFF;
    font-size: 16px;
    white-space: nowrap;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.8);
  }
  @media(max-width: ${maxMobile}px) {
    height: 28px;
  }
`;

const InfoLabel = styled.div`
  font-size: 12px;
`;

const PopupContainer = styled.div`
  width: 100%;
  font-size: 16px;
  color: #000000;
  padding: 0 35px;
  > div:first-child {
    margin-bottom: 32px;
  }
`;

const PopupHeader = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`;

const PopupContent = () => (
  <PopupContainer>
    <div>
      <PopupHeader>罷免通過門檻</PopupHeader>
      <div>同意票數多於不同意票數，且同意票數超過原選舉區選舉人總數的1/4 。</div>
    </div>
    <div>
      <PopupHeader>資料來源</PopupHeader>
      <div>總投票人數為有效票及無效票加總的票數，有效票包含同意票與不同意票。</div>
      <div>所有票數以中選會為準。</div>
    </div>
  </PopupContainer>
);

const GraphicInfoContainer = styled.div`
  position: relative;
`;

const MaskContainer = styled.div`
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: 6;
  background-color: rgba(196, 196, 196, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  > span {
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 10px;
  }
  > img {
    width: 45px;
  }
`;


const Graphic = memo(({
  halfNumberOfElector,
  numberOfAgree,
  numberOfDisagree,
}) => {
  const agreeWidth = (() => {
    if (!numberOfAgree) {
      return 0;
    } else {
      if (numberOfAgree < halfNumberOfElector) {
        return numberOfAgree/halfNumberOfElector * 100;
      } else {
        return 100;
      }
    }
  })();
  const disagreeWidth = numberOfDisagree ? numberOfDisagree/halfNumberOfElector * 100 : 0;
  return (
    <GraphicContainer>
      <LabelContainer>
        <GraphicLable>同意</GraphicLable>
        <GraphicLable>不同意</GraphicLable>
      </LabelContainer>
      <DataContainer>
        <Agree
          width={agreeWidth}
        >
          <span>{voteNumberToString(numberOfAgree)}</span>
        </Agree>
        <Disagree
          width={disagreeWidth}
        >
          <span>{voteNumberToString(numberOfDisagree)}</span>
        </Disagree>
        <Pass>
          <PassLabel>
            {`${voteNumberToString(Math.ceil(halfNumberOfElector/2))}`}
            <br/>
            同意票數最低門檻
          </PassLabel>
        </Pass>
      </DataContainer>
    </GraphicContainer>
  )
})

const defaultData = {
  updatedAt: null,
  numberOfYeses: 0,
  numberOfNos: 0,
  attemptedVoteCount: 0,
};


class Infographic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifOpen: false,
      cecData: defaultData,
      error: null,
    }
    this.infographic = null;
    this.upperHalfRef = null;
    this.trackNavbarLocation = this._trackNavbarLocation.bind(this);
    this.fetchData = this._fetchData.bind(this);
    this.trackResize = this._trackResize.bind(this);
    this.previousScrollY = null;
    this.onHandlePopup = this._onHandlePopup.bind(this);
    this.trackScrollTimeout = null;
    this.interval = null;
  }

  componentDidMount() {
    if (this.infographic && window && document) {
      document.addEventListener('scroll', this.trackNavbarLocation);
      window.addEventListener('resize', this.trackResize);
      this.previousTop = this.infographic.getBoundingClientRect().top;
    }
    if (currentStage >= stage.live) {
      this.fetchData();
      if (currentStage === stage.live) {
        this.interval = setInterval(this.fetchData, updateInterval);
      }
    }
  }

  componentWiiUnmount() {
    document.removeEventListener('scroll', this.trackNavbarLocation);
    window.removeEventListener('resize', this.trackResize);
    clearInterval(this.interval);
  }

  _fetchData() {
    fetchDataFromCEC()
      .then((cecData) => {
        console.log('fetch data from CEC')
        this.setState({
          cecData,
          errorMessage: null,
        })
      })
      .catch((err) => {
        // this.setState({
        //   cecData: null,
        //   errorMessage: '目前尚無資料',
        // })
      })
  }

  _onHandlePopup({
    ifOpen,
  }) {
    this.setState({
      ifOpen,
    });
  }

  _trackResize() {
    // need to be fixed
    if (this.infographic && this.upperHalfRef && window && window.innerWidth >= maxMobile) {
      this.infographic.style.position = 'sticky';
      this.infographic.style.zIndex = '5';
      this.infographic.style.left = 'initial';
      this.infographic.style.padding= 'initial';
      this.upperHalfRef.style.paddingTop = 'initial';
    };
    // if (this.infographic && this.upperHalfRef && window && window.innerWidth <= maxMobile) {
    //   this._trackNavbarLocation();
    // };
  }

  _trackNavbarLocation() {
    if (!this.upperHalfRef) {
      const { getUpperHalfRef } = this.props;
      this.upperHalfRef = getUpperHalfRef();
    }
    if (this.infographic && window && window.innerWidth <= maxMobile) {
      const currentTop = this.infographic.getBoundingClientRect().top;
      const currentBottom = this.infographic.getBoundingClientRect().bottom;
      const parentTop = this.upperHalfRef.getBoundingClientRect().top;
      const parentBottom = this.upperHalfRef.getBoundingClientRect().bottom;
      const userScrollDown = this.previousScrollY < window.scrollY;
      if (currentTop <= 0 && userScrollDown && (this.infographic.style.position === '' || this.infographic.style.position === 'relative')) {
        this.infographic.style.position = 'fixed';
        this.infographic.style.zIndex = '1000';
        this.infographic.style.left = '0';
        this.infographic.style.paddingLeft= '15px';
        this.infographic.style.paddingRight= '15px';
        this.upperHalfRef.style.paddingTop = `${this.infographic.offsetHeight}px`;
      } else if (parentTop >= 0  && !userScrollDown && this.infographic.style.position === 'fixed') {
        this.infographic.style.position = 'relative';
        this.infographic.style.zIndex = '5';
        this.infographic.style.top ='0';
        this.infographic.style.left = 'initial';
        this.infographic.style.paddingLeft= 'initial';
        this.infographic.style.paddingRight= 'initial';
        this.upperHalfRef.style.paddingTop = '0px';
      }else if (currentBottom >= parentBottom  && userScrollDown && this.infographic.style.position === 'fixed') {
        this.infographic.style.position = 'absolute';
        this.infographic.style.bottom = '0';
        this.infographic.style.top = 'initial';
      }else if (currentTop >=0 && !userScrollDown && this.infographic.style.position === 'absolute') {
        this.infographic.style.position = 'fixed';
        this.infographic.style.zIndex = '1000';
        this.infographic.style.left = '0';
        this.infographic.style.paddingLeft= '15px';
        this.infographic.style.paddingRight= '15px';
        this.infographic.style.bottom = 'initial';
        this.infographic.style.top = '0';
      }
      this.previousScrollY = window.scrollY;
    }
  }

  _renderData() {
    const { cecData, errorMessage } = this.state
    if (!cecData) {
      if (errorMessage) {
        return <div style={{color: 'red'}}>{errorMessage}</div>
      }
      return null;
    }
    const {
      updatedAt,
      numberOfYeses,
      numberOfNos,
      attemptedVoteCount,
    } = cecData;
    const Mask = () => {
      if (currentStage >= stage.live) {
        return null;
      }
      return (
        <MaskContainer>
          <span>尚未開票</span>
          <img src={RecallLoading} alt="尚未開票圖檔" />
        </MaskContainer>
      )
    }
    return (
      <GraphicInfoContainer>
        <Mask />
        <Graphic
          halfNumberOfElector={Math.ceil(votingEligiblePopulation/2)}
          numberOfAgree={numberOfYeses}
          numberOfDisagree={numberOfNos}
          numberOfTotalVotes={attemptedVoteCount}
        />
      <InfoLabel>{`總票數：${voteNumberToString(attemptedVoteCount)}（${(attemptedVoteCount/votingEligiblePopulation * 100).toFixed(2)}%）`}</InfoLabel>
        <InfoLabel>{`最後更新時間：${cecDateStringToHumanRead(updatedAt)}`}</InfoLabel>
      </GraphicInfoContainer>
    );
  }


  render() {
    const { ifOpen } = this.state;

    return (
      <Container
        id="infographic"
        ref={(node) => this.infographic = node}
      >
        <Header>
          <span>高雄市長罷免案開票結果</span>
          <img
            src={InfoIcon} alt="info icon, you can click it to show more info"
            onClick={() => {
              this.onHandlePopup({
                ifOpen: true,
              })
            }}
          />
        </Header>
        {this._renderData()}
        <Popup
          ifOpen={ifOpen}
          onHandlePopup={this.onHandlePopup}
          Content={<PopupContent />}
        />
      </Container>
    )
  }
}


export default Infographic;
